<template>
    <InternalFormError
        v-if="errors.isInternalServerError"
        :errors
        class="action-error"
    />

    <UnmappedErrors
        v-else-if="errors.unmapped.length"
        class="action-error"
        :errors="errors.unmapped"
    />
</template>

<script setup lang="ts">
import type { ErrorCollectionWithTraces } from '@/helpers/errors'

import UnmappedErrors from '@/components/ui/form/error/UnmappedErrors.vue'
import InternalFormError from '@/components/ui/form/error/InternalFormError.vue'

defineProps<{
    errors: ErrorCollectionWithTraces
}>()
</script>

<style lang="scss" scoped>
.action-error {
    margin: 1.5rem 0;
}
</style>
